import { ExpenseLineExpenseType } from "Infrastructure/ApiZfp/Schema";

export const EXPENSE_TYPE_ORDER: ExpenseLineExpenseType[] = [
  ExpenseLineExpenseType.housing,
  ExpenseLineExpenseType.consumption,
  ExpenseLineExpenseType.life_style,
  ExpenseLineExpenseType.loan,
  ExpenseLineExpenseType.insurance,
  ExpenseLineExpenseType["financial-product"],
  ExpenseLineExpenseType.other,
];

/**
 * Maps the API expense type onto its key in `Resources.AnalysisDetail.Budget.Expenses.ExpenseTypes`.
 * The API values are snake-cased (and `financial-product` is hyphenated), so they cannot be used
 * as translation keys directly.
 */
export const EXPENSE_TYPE_TRANSLATION_KEY: Record<
  ExpenseLineExpenseType,
  "Housing" | "Consumption" | "LifeStyle" | "Loan" | "Insurance" | "FinancialProduct" | "Other"
> = {
  [ExpenseLineExpenseType.housing]: "Housing",
  [ExpenseLineExpenseType.consumption]: "Consumption",
  [ExpenseLineExpenseType.life_style]: "LifeStyle",
  [ExpenseLineExpenseType.loan]: "Loan",
  [ExpenseLineExpenseType.insurance]: "Insurance",
  [ExpenseLineExpenseType["financial-product"]]: "FinancialProduct",
  [ExpenseLineExpenseType.other]: "Other",
};
